import { Divider } from '@mui/material';
import React from 'react';

import { variables } from '../../../contexts/ThemeProvider';

export const ErrorLine = () => {
  return (
    <Divider
      orientation="vertical"
      flexItem
      sx={{
        position: 'absolute',
        left: -10,
        height: '100%',
        borderWidth: 2,
        borderColor: variables.errorRed,
      }}
    />
  );
};
